import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import useStyles from './styles'
import clsx from 'clsx'

const PaywallSuccessToast = () => {
    const classes = useStyles()
    const [fadeOut, setFadeOut] = useState(false)

    useEffect(() => {
        const timer = setTimeout(() => setFadeOut(true), 1200)
        return () => clearTimeout(timer)
    }, [setFadeOut])

    return (
        <div className={classes.container}>
            <span className={clsx(classes.successCheckMark, fadeOut && [classes.fadeOut])}>
                <FontAwesomeIcon icon={faCheck} className={classes.successCheckMarkIcon} />
            </span>
            <span className={clsx(classes.successToast, fadeOut && [classes.fadeOut])}>Success!</span>
        </div>
    )
}

export default React.memo(PaywallSuccessToast)
